// Redirect to the same page with the locale updated from the user account settings
// console.log('to.fullPath', to.fullPath)
// let clearedLocateFromPath = to.fullPath.split('/').slice(2)
// clearedLocateFromPath.unshift(userLocale)
// let correctedUrl = '/' + clearedLocateFromPath.join('/')
// console.log('result', correctedUrl)
const updateRedirectToUsersLocale = (fullPath, userLocale) => {
  let clearedLocateFromPath = fullPath.split('/').slice(2) // Asumes that the fullPath always starts with a /
  clearedLocateFromPath.unshift(userLocale)
  let correctedUrl = '/' + clearedLocateFromPath.join('/') // The / is needed in the beginning so the router don't add the url on top of another path
  return correctedUrl
}

export {
  updateRedirectToUsersLocale
}



// WEBPACK FOOTER //
// ./src/utils/redirectLocale.js